<div class="text-top">
    <span style="margin-bottom: 0;">Impostazioni società</span>
</div>
<div class="sub-menu">
    <span (click)="setTabNumber(4)" [ngClass]="{'active': tabNumber === 0}">Documenti Well Done</span>
</div>

<ng-container *ngIf="tabNumber === 0">


    <p class="welldone-text-gray" style="font-size: 14px;">In questa sezione vengono caricati tutti i documenti richiesti
        alla società da parte di Well Done.</p>
    <div class="welldone-card mb-4">
        <div class="welldone-card-header">
            Aggiungi/Modifica Documento
        </div>
        <div class="welldone-card-body">
            <form #adminDocumentForm="ngForm" class="w-100">

                <div class="container-fluid">
                    <div class="row mb-3">
                        <div class="col-4">
                            <span class="required">Nome documento</span>
                        </div>
                        <div class="col-8">
                            <input type="text" class="form-control form-control-solid"
                                   [(ngModel)]="adminDocument.name" name="document-name" required/>
                        </div>
                    </div>
                    <div class="row mb-3">
                        <div class="col-4"><span>Descrizione</span></div>
                        <div class="col-8"><textarea class="form-control form-control-solid"
                                                     [(ngModel)]="adminDocument.description"
                                                     name="document-description"></textarea></div>
                    </div>
                    <div class="row mb-3">
                        <div class="col-4"><span class="required"> E' obbligatorio</span></div>
                        <div class="col-8">
                            <select class="form-control form-select form-select-solid"
                                    [(ngModel)]="adminDocument.isMandatory" name="document-mandatory" required>
                                <option value="1" selected>
                                    Sì
                                </option>
                                <option value="0">
                                    No
                                </option>
                            </select>
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-4"><span class="required">Ha una data di scadenza?</span></div>
                        <div class="col-8">
                            <select class="form-control form-select form-select-solid"
                                    [(ngModel)]="adminDocument.hasExpirationDate" name="document-expire" required>
                                <option value="1" selected>
                                    Sì
                                </option>
                                <option value="0">
                                    No
                                </option>
                            </select>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-4">
                            <label for="model-document"
                                class="form-label">Modello documento</label>
                        </div>
                        <div class="col-8">
                        <input type="file" class="form-control form-control-solid" id="model-document"
                               aria-describedby="model-document" aria-label="Upload"
                               (change)="chooseDocumentModel($event)"
                               name="model-document"
                        />
                        </div>
                    </div>
                </div>
            </form>
        </div>
        <div class="welldone-card-footer">
            <button class="btn btn-primary" [disabled]="adminDocumentForm.invalid" (click)="uploadDocument($event)">
                Salva
            </button>
        </div>
    </div>

    <ui-table #adminDocumentsTable table-title="Documenti caricati">
        <ng-template #customHeader>
            <tr>
                <th>Nome</th>
                <th>Descrizione</th>
                <th>Richiesto</th>
                <th>Ha Scadenza?</th>
                <th>Anteprima Modulo</th>
                <th></th>
            </tr>
        </ng-template>

        <ng-template #customRow let-row="row">
            <tr>
                <td> {{ row.name }} </td>
                <td> {{ row.description ?? '' }} </td>
                <td>
                    <span class="badge badge-success" *ngIf="row.isMandatory"> Obbligatorio</span>
                    <span class="badge badge-error" *ngIf="!row.isMandatory"> Non obbligatorio</span>
                </td>
                <td>
                    <span class="badge badge-success" *ngIf="row.hasExpirationDate"> Con scadenza</span>
                    <span class="badge badge-error" *ngIf="!row.hasExpirationDate"> Senza scadenza</span>
                </td>
                <td>
                    <a *ngIf="row.modelUrl && row.modelUrl !== ''" [href]="row.modelUrl">Visualizza Anteprima</a>
                </td>
                <td>
                    <div class="d-flex justify-content-end gap-3">
                        <button class="btn welldone-btn-gray" (click)="openEditDocumentModal(row)">
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                                 class="bi bi-pencil" viewBox="0 0 16 16">
                                <path d="M12.146.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1 0 .708l-10 10a.5.5 0 0 1-.168.11l-5 2a.5.5 0 0 1-.65-.65l2-5a.5.5 0 0 1 .11-.168l10-10zM11.207 2.5 13.5 4.793 14.793 3.5 12.5 1.207 11.207 2.5zm1.586 3L10.5 3.207 4 9.707V10h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.293l6.5-6.5zm-9.761 5.175-.106.106-1.528 3.821 3.821-1.528.106-.106A.5.5 0 0 1 5 12.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.468-.325z"/>
                            </svg>
                        </button>
                        <button class="btn welldone-btn-gray" (click)="removeDocumentModel(row)">
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                                 class="bi bi-trash" viewBox="0 0 16 16">
                                <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5Zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5Zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6Z"/>
                                <path d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1ZM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118ZM2.5 3h11V2h-11v1Z"/>
                            </svg>
                        </button>
                    </div>
                </td>
            </tr>
        </ng-template>
    </ui-table>
</ng-container>


<ngx-smart-modal #editDocumentModal identifier="editDocumentModal" (onClose)="clearModalData('editDocumentModal')">
    <ng-container *ngIf="editDocumentModal.hasData()">
        <div class="welldone-card-header">Modifica documento</div>
        <div class="welldone-card-body">
            <form #adminDocumentEditForm="ngForm" class="w-100">

                <div class="container-fluid p-0">
                    <div class="row mb-3">
                        <div class="col-4">
                            <span class="required">Nome documento</span>
                        </div>
                        <div class="col-8">
                            <input type="text" class="form-control form-control-solid"
                                   [(ngModel)]="editDocumentModal.getData().name" name="document-name" required/>
                        </div>
                    </div>
                    <div class="row mb-3">
                        <div class="col-4"><span>Descrizione</span></div>
                        <div class="col-8"><textarea class="form-control form-control-solid"
                                                     [(ngModel)]="editDocumentModal.getData().description"
                                                     name="document-description"></textarea></div>
                    </div>
                    <div class="row mb-3">
                        <div class="col-4"><span class="required"> E' obbligatorio</span></div>
                        <div class="col-8">
                            <select class="form-control form-select form-select-solid"
                                    [(ngModel)]="editDocumentModal.getData().isMandatory" name="document-mandatory"
                                    required>
                                <option value="1" [selected]="editDocumentModal.getData().isMandatory == 1">
                                    Sì
                                </option>
                                <option value="0" [selected]="editDocumentModal.getData().isMandatory == 0">
                                    No
                                </option>
                            </select>
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-4"><span class="required">Ha una data di scadenza?</span></div>
                        <div class="col-8">
                            <select class="form-control form-select form-select-solid"
                                    [(ngModel)]="editDocumentModal.getData().hasExpirationDate"
                                    name="document-expire" required>
                                <option value="1" [selected]="editDocumentModal.getData().hasExpirationDate == 1">
                                    Sì
                                </option>
                                <option value="0" [selected]="editDocumentModal.getData().hasExpirationDate == 0">
                                    No
                                </option>
                            </select>
                        </div>
                    </div>
                    <div class="row mb-3">
                        <div class="col-4">
                            <label for="model-document-edit" class="form-label">Modello documento</label>
                        </div>
                        <div class="col-8">
                            <input type="file" class="form-control form-control-solid" id="model-document-edit"
                                   aria-describedby="model-document" aria-label="Upload"
                                   (change)="chooseDocumentModel($event)"
                                   name="model-document"
                            />
                        </div>
                    </div>
                </div>
            </form>
        </div>
        <div class="welldone-card-footer">
            <button class="btn btn-primary" [disabled]="adminDocumentEditForm.invalid"
                    (click)="updateDocument(editDocumentModal.getData())">Aggiorna
            </button>
        </div>
    </ng-container>
</ngx-smart-modal>
